import { api } from '#/shared/api'

export const changePassword = async (email: string, password_1: string, password_2: string) => {
	return await api.patch<{ detail: string }>(`/auth/business-host/account/change-pass/${email}`, {
		password_1,
		password_2,
	})
}
